import { ArticleDetailsPageProps, WithGlobalData } from '@domains/view';

import { BFFCookieClientClass } from '@api/client/bff';
import { NewsDetailsPayload } from '@api/protocol';

import { Article } from '@views/Article/Article';

type QueryParams = {
    slug: QueryParam;
};
export const getServerSideProps: BFF.GetPageServerSideProps<
    WithGlobalData<ArticleDetailsPageProps>,
    QueryParams
> = async (context) => {
    const { req, params } = context;
    const slug = params?.slug ?? '';
    const formattedSlug = typeof slug === 'string' ? slug : slug.join('/');

    return BFFCookieClientClass<ArticleDetailsPageProps>({
        isNotFoundOnErrorShown: true,
        request: req,
    })
        .addToStack<NewsDetailsPayload>({
            prop: 'data',
            url: '/api/news/details',
            payload: { slug: formattedSlug },
        })
        .getServerProps();
};

export default Article;
